const DeliveryStatus = {
    transport: 'Processo de Transporte já Iniciado',
    entregue: 'Entrega Realizada Normalmente',
    entregaForadaDataProgramada: 'Entrega Fora da Data Programada',
    recusaporFaltadePedidodeCompra: 'Recusa por Falta de Pedido de Compra',
    recusaporPedidodeCompraCancelado: 'Recusa por Pedido de Compra Cancelado',
    faltadeEspacoFisiconoDepositodoClienteDestino:
        'Falta de Espaço Físico no Depósito do Cliente Destino',
    endereçodoClienteDestinonãoLocalizado:
        'Endereço do Cliente Destino não Localizado',
    devoluçãonãoAutorizadapeloCliente: 'Devolução não Autorizada pelo Cliente',
    preçoMercadoriaemDesacordocomoPedidoCompra:
        'Preço Mercadoria em Desacordo com o Pedido Compra',
    mercadoriaemDesacordocomoPedidoCompra:
        'Mercadoria em Desacordo com o Pedido Compra',
    clienteDestinosomenteRecebeMercadoriacomFretePago:
        'Cliente Destino somente Recebe Mercadoria com Frete Pago',
    recusaporDeficiênciaEmbalagemMercadoria:
        'Recusa por Deficiência Embalagem Mercadoria',
    RedespachonãoIndicado: 'Redespacho não Indicado',
    TransportadoranãoAtendeaCidadedoClienteDestino:
        'Transportadora não Atende a Cidade do Cliente Destino',
    MercadoriaSinistrada: 'Mercadoria Sinistrada',
    EmbalagemSinistrada: 'Embalagem Sinistrada',
    PedidodeComprasemDuplicidade: 'Pedido de Compras em Duplicidade',
    MercadoriaforadaEmbalagemdeAtacadista:
        'Mercadoria fora da Embalagem de Atacadista',
    MercadoriasTrocadas: 'Mercadorias Trocadas',
    ReentregaSolicitadapeloCliente: 'Reentrega Solicitada pelo Cliente',
    EntregaPrejudicadaporHorárioOuFaltadeTempoHábil:
        'Entrega Prejudicada por Horário/Falta de Tempo Hábil',
    EstabelecimentoFechado: 'Estabelecimento Fechado',
    ReentregasemCobrançadoCliente: 'Reentrega sem Cobrança do Cliente',
    ExtraviodeMercadoriaemTrânsito: 'Extravio de Mercadoria em Trânsito',
    MercadoriaReentregueaoClienteDestino:
        'Mercadoria Reentregue ao Cliente Destino',
    MercadoriaDevolvidaaoClientedeOrigem:
        'Mercadoria Devolvida ao Cliente de Origem',
    NotaFiscalRetidapelaFiscalização: 'Nota Fiscal Retida pela Fiscalização',
    RoubodeCarga: 'Roubo de Carga',
    MercadoriaRetidaatéSegundaOrdem: 'Mercadoria Retida até Segunda Ordem',
    ClienteRetiraMercadorianaTransportador:
        'Cliente Retira Mercadoria na Transportadora',
    ProblemacomaDocumentação:
        'Problema com a Documentação [Nota Fiscal e/ou CTRC]',
    EntregacomIndenizaçãoEfetuada: 'Entrega com Indenização Efetuada',
    FaltacomSolicitacaodeReposição: 'Falta com Solicitação de Reposição',
    FaltacomBuscaOuReconferência: 'Falta com Busca/Reconferência',
    ClienteFechadoparaBalanço: 'Cliente Fechado para Balanço',
    QuantidadedeProdutoemDesacordo:
        'Quantidade de Produto em Desacordo [Nota Fiscal e/ou Pedido]',
    ExtraviodedocumentospelaciaAérea: 'Extravio de documentos pela cia. Aérea',
    ExtraviodecargapelaciaAérea: 'Extravio de carga pela cia. Aérea',
    AvariadecargapelaciaAérea: 'Avaria de carga pela cia. Aérea',
    Cortedecarganapista: 'Corte de carga na pista',
    Aeroportofechadonaorigem: 'Aeroporto fechado na origem',
    PedidodeCompraIncompleto: 'Pedido de Compra Incompleto',
    NotaFiscalcomProdutosdeSetoresDiferentes:
        'Nota Fiscal com Produtos de Setores Diferentes',
    FeriadoLocalOuNacional: 'Feriado Local/Nacional',
    ExcessodeVeículos: 'Excesso de Veículos',
    ClienteDestinoEncerrouAtividades: 'Cliente Destino Encerrou Atividades',
    ResponsáveldeRecebimentoAusente: 'Responsável de Recebimento Ausente',
    ClienteDestinoemGreve: 'Cliente Destino em Greve',
    Aeroportofechadonodestino: 'Aeroporto fechado no destino',
    Vôocancelado: 'Vôo cancelado',
    Grevenacional: 'Greve nacional [Greve Geral]',
    MercadoriaVencida: 'Mercadoria Vencida [Data de Validade Expirada]',
    MercadoriaRedespachada:
        'Mercadoria Redespachada [Entregue para Redespacho]',
    MercadorianãofoiEmbarcadaPermanecendonaOrigem:
        'Mercadoria não foi Embarcada, Permanecendo na Origem',
    MercadoriaEmbarcadasemConhecimentoConhecimentonãoEmbarcado:
        'Mercadoria Embarcada sem Conhecimento/Conhecimento não Embarcado',
    EndereçodeTransportadoradeRedespachonãoLocalizadoInformado:
        'Endereço de Transportadora de Redespacho não Localizado/Informado',
    ClientenãoAceitaMercadoriacomPagamentodeReembolso:
        'Cliente não Aceita Mercadoria com Pagamento de Reembolso',
    TransportadoranãoAtendeaCidadedaTransportadoradeRedespacho:
        'Transportadora não Atende a Cidade da Transportadora de Redespacho',
    QuebradoVeiculodeEntrega: 'Quebra do Veiculo de Entrega',
    ClientesemVerbaparaPagaroFrete: 'Cliente sem Verba para Pagar o Frete',
    EndereçodeEntregaErrado: 'Endereço de Entrega Errado',
    ClientesemVerbaparaReembolso: 'Cliente sem Verba para Reembolso',
    RecusadaCargaporValordeFreteErrado:
        'Recusa da Carga por Valor de Frete Errado',
    IdentificaçãodoClientenãoInformadaOuEnviadaOuInsuficiente:
        'Identificação do Cliente não Informada/Enviada/Insuficiente',
    ClientenãoIdentificadoOuCadastrado: 'Cliente não Identificado/Cadastrado',
    EntraremContatocomoComprador: 'Entrar em Contato com o Comprador',
    TrocanãoDisponível: 'Troca não Disponível',
    FinsEstatísticos: 'Fins Estatísticos',
    DatadeEntregaDiferentedoPedido: 'Data de Entrega Diferente do Pedido',
    SubstituiçãoTributária: 'Substituição Tributária',
    SistemaForadoAr: 'SistemaForadoAr',
    ClienteDestinonãoRecebePedidoParcial:
        'ClienteDestinonãoRecebePedidoParcial',
    ClienteDestinosóRecebePedidoParcial: 'ClienteDestinosóRecebePedidoParcial',
    RedespachosomentecomFretePago: 'Redespacho somente com Frete Pago',
    FuncionárionãoautorizadoaReceberMercadorias:
        'Funcionário não autorizado a Receber Mercadorias',
    MercadoriaEmbarcadaparaRotaIndevida:
        'Mercadoria Embarcada para Rota Indevida',
    EstradaOuEntradadeAcessoInterditada:
        'Estrada/Entrada de Acesso Interditada',
    ClienteDestinoMudoudeEndereço: 'Cliente Destino Mudou de Endereço',
    AvariaTotal: 'Avaria Total',
    AvariaParcial: 'Avaria Parcial',
    ExtravioTotal: 'Extravio Total',
    ExtravioParcial: 'Extravio Parcial',
    SobradeMercadoriasemNotaFiscal: 'Sobra de Mercadoria sem Nota Fiscal',
    MercadoriaempoderdaSUFRAMAparaInternação:
        'Mercadoria em poder da SUFRAMA para Internação',
    MercadoriaRetiradaparaConferência: 'Mercadoria Retirada para Conferência',
    ApreensãoFiscaldaMercadoria: 'Apreensão Fiscal da Mercadoria',
    ExcessodeCargaOuPeso: 'Excesso de Carga/Peso',
    FériasColetivas: 'Férias Coletivas',
    Recusadoaguardandonegociação: 'Recusado, aguardando negociação',
    Aguardandorefaturamentodasmercadorias:
        'Aguardando refaturamento das mercadorias',
    RecusadopeloRedespachante: 'Recusado pelo Redespachante',
    EntregaProgramada: 'Entrega Programada',
    ProblemasFiscais: 'Problemas Fiscais',
    Aguardandocartadecorreção: 'Aguardando carta de correção',
    Recusapordivergêncianascondiçõesdepagamento:
        'Recusa por divergência nas condições de pagamento',
    Cargaaguardandovôoconexão: 'Carga aguardando vôo conexão',
    CargasemembalagemprópriaparatranspAéreo:
        'Carga sem embalagem própria para transp. Aéreo',
    Cargacomdimensãosuperioraoporãodaaeronave:
        'Carga com dimensão superior ao porão da aeronave',
    Chegadanacidadeoufilialdedestino: 'Chegada na cidade ou filial de destino',
    Outrostiposdeocorrênciasnãoespecificadosacima:
        'Outros tipos de ocorrências',
    Devolucaopornaocumprimentodoagendamento:
        'Devolução por não cumprimento do agendamento',
    Devolucaoapedidodoembarcador:
        'Devolução/não entrega a pedido do embarcador ',
    Devolucaoapedidododestinatário:
        ' Devolução/não entrega a pedido do destinatário',
    Devolucaoapedidotransportadoraderedespacho:
        'Devolução/não entrega a pedido transportadora de redespacho',
    EntregaefetuadanaTransportadoradeRedespacho:
        'Entrega efetuada na Transportadora de Redespacho',
    EntregaefetuadanoclientepelaTransportadoradeRedespacho:
        'Entrega efetuada no cliente pela Transportadora de Redespacho',
    DatadaretiradaemManaus: 'Data da retirada em Manaus',
    Placadacarretaresponsavelpelotransporte:
        'Placa da carreta responsável pelo transporte',
    Nomedabalsa: 'Nome da balsa',
    Nomedoempurrador: 'Nome do empurrador',
    Numerodafrota: 'Numero da frota',
    DatadechegadaemBelem: 'Data de chegada em Belém',
    DatadesaidadeBelem: 'Data de saida de Belém',
    Datadechegadanatransportadora: 'Data de chegada na transportadora',
    Datadesaidadatransportadora: 'Data de saída da transportadora',
    DatadechegadanoPorto: 'Data de chegada no Porto',
    DatadesaidadoPorto: 'Data de saida do Porto',
    DatadechegadanasegundaTransportadora:
        'Data de chegada na segunda Transportadora',
    DatadesaidadasegundaTransportadora:
        'Data de saida da segunda Transportadora',
    emTransitoParaUnidade: 'Em transito para a unidade',
    emTransitoParaCidadeDestino: 'Em transito para a cidade de destino',
    saiuParaEntrega: 'Saiu para entrega',
    naoListado: 'Não Listado',
    azul571: 'Status Azul Linhas aéreas'
}

function useDeliveryStatus(status: string) {
    return DeliveryStatus.hasOwnProperty(status)
        ? DeliveryStatus[status]
        : 'Não Listado'
}

export { useDeliveryStatus }
